import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  IOpenEndedQuestionModelState,
  IOpenEndedResponseValidation,
  OpenEndedQuestionModelTypes,
  OpenEndedSubmitResponse
} from './types'

const OpenEndedQuestionModel: IQuestionModelConstructor<OpenEndedQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<OpenEndedQuestionModelTypes, IOpenEndedQuestionModelState>({
    questionType: QuestionType.OPEN_ENDED,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IOpenEndedQuestionModelState) {
  const submitAnswer: ArrayElementType<OpenEndedSubmitResponse> = { id: response.id, c: response.comment }
  return [submitAnswer]
}

function initState(state: IOpenEndedQuestionModelState): IOpenEndedQuestionModelState {
  state.response = { id: state.questionSchema.id, comment: '' }
  return state
}

function validateResponse({
  response,
  questionSchema,
  responseValidation
}: IOpenEndedQuestionModelState): IOpenEndedResponseValidation {
  if (questionSchema.validation_url) return responseValidation
  const min = questionSchema.min_characters || 0
  const max = questionSchema.max_characters || 5000
  const optional = questionSchema.optional
  const comment = response.comment.trim()

  return 0 === comment.length ? { valid: optional } : { valid: comment.length >= min && comment.length <= max }
}

export default OpenEndedQuestionModel
